<template>
  <div class="ui two column stackable grid" v-if="activeSubscription">
    <div class="sixteen wide mobile six wide tablet four wide computer column">
      <div class="ui one cards">
        <div class="card">
          <div class="content">
            <div class="header">{{ FullName }}</div>
            <div class="meta">
              <a>{{ addressLine }}</a>
            </div>

            <div class="description" v-if="mandatoryFields.length > 0">
              <div class="info-piece" v-for="merchantField in mandatoryFields" :key="merchantField.id">
                <div class="info-label">{{ merchantField.name }}</div>
                <div class="info-text">{{ merchantField.meta.value }}</div>
              </div>
            </div>
          </div>

          <div class="extra content">
						<span>
							<i class="payment icon"/>
							{{ subscriptions.total }} {{ $t('pages.dashboard.details.subscriptions') }}
						</span>
          </div>
        </div>
      </div>

      <div class="ui one cards"
           v-if="$store.getters.activeMerchant.kamstrup && activeSubscription.product.category.water_meter">
        <div class="card">
          <div class="content" v-if="activeSubscription.kamstrup_user">
            <div class="header" style="color: #f39c12;">Kamstrup</div>
            <p>{{ $t('pages.dashboard.details.kamstrup.headers.meter_info') }}</p>
            <div class="description">
              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.meter_serial_number') }}</div>
                <div class="info-text">{{ activeSubscription.kamstrup_user.meter_number }}
                </div>
              </div>
              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.meter_type') }}</div>
                <div class="info-text">{{ activeSubscription.kamstrup_user.meter_type }}
                </div>
              </div>
              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.consumption_type') }}</div>
                <div class="info-text">{{ activeSubscription.kamstrup_user.consumption_type }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui one cards"
           v-if="$store.getters.activeMerchant.kamstrup && activeSubscription.product.category.water_meter">

        <div class="card">
          <!-- Current period -->
          <div class="content" v-if="currentMeter">
            <div class="header" style="color: #f39c12;">Kamstrup - {{ $t('pages.dashboard.details.kamstrup.current_period') }}</div>
            <p>{{ $t('pages.dashboard.details.kamstrup.headers.meter_data') }}</p>

            <div class="description">
              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.from') }}</div>
                <div class="info-text">{{ currentFrom }}</div>
              </div>

              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.to') }}</div>
                <div class="info-text">{{ currentTo }}</div>
              </div>

              <div class="info-piece">
                <div class="info-label" style="color: #00a9f7;">{{ $t('pages.dashboard.details.kamstrup.total') }}</div>
                <div v-if="currentMeter.meter_reading_total !== null" class="info-text">
                  {{ currentMeter.meter_reading_total }} m<sup>3</sup>
                </div>
                <div v-else>
                  -
                </div>
              </div>
            </div>
          </div>

          <!-- Previous period -->
          <div class="content" v-if="previousMeter">
            <div class="header" style="color: #7f8c8d;">Kamstrup - {{ $t('pages.dashboard.details.kamstrup.previous_period') }}</div>

            <div class="description">
              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.from') }}</div>
                <div class="info-text">{{ previousFrom }}</div>
              </div>

              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.to') }}</div>
                <div class="info-text">{{ previousTo }}</div>
              </div>

              <div class="info-piece">
                <div class="info-label">{{ $t('pages.dashboard.details.kamstrup.total') }}</div>
                <div class="info-text">{{ previousMeter.meter_reading_total }} m<sup>3</sup></div>
              </div>
            </div>
          </div>

          <!-- No current meter -->
          <div class="content" v-if="!currentMeter">
            <div class="header" style="color: #f39c12;">Kamstrup</div>
            <p>{{ $t('pages.dashboard.details.kamstrup.headers.meter_data') }}</p>

            <div class="description">
              <div class="info-piece">
                <div class="info-label" style="color: #00a9f7;">{{ $t('pages.dashboard.details.kamstrup.total') }}</div>
                <div class="info-text">0</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="sixteen wide mobile ten wide tablet twelve wide computer column"
         v-if="editableFields.length > 0 || showMobilePayNotice">
      <div class="ui padded segment" :class="{ 'loading' : showLoader }">
        <div class="ui horizontal divider header">{{ activeSubscription.product.name }}</div>
        <template v-if="showMobilePayNotice">
          <div class="ui divider"></div>
          <div class="ui horizontal red header" style="text-align: center;">
            {{ $t('pages.dashboard.details.mobile_pay_instant_notice') }}
          </div>
          <div class="ui divider"></div>
        </template>
        <div class="ui zw form error" data-vv-scope="editForm">
          <div class="two fields" v-for="(editableField, index) in chunkProperty(editableFields, 2)" :key="index">
            <field v-for="field in editableField"
                   v-if="field"
                   :key="field.id"
                   :field="field"
                   :allowEdit="allowEditing"
                   :isactive="activeSubscription.status === 'active' || activeSubscription.status === 'delayed'"
                   :scope="'editForm'"
                   @input="changeFieldValue"
                   :value="fieldValues"
                   :transparent="!allowEditing"/>
          </div>

          <div class="ui blue button" v-if="editableFields.length > 0 && isNotInactive && !allowEditing"
               @click="showEditForm()">
            <i class="edit icon"/>
            {{ $t('globals.buttons.edit') }}
          </div>

          <button type="submit" @click="saveEditForm('editForm')" class="ui green button" v-else-if="allowEditing">
            <i class="checkmark icon"/>
            {{ $t('globals.buttons.save') }}
          </button>

          <div class="ui red button" v-if="allowEditing" @click="cancelEditForm('editForm')">
            <i class="cancel icon"/>
            {{ $t('globals.buttons.cancel') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from 'lodash/chunk'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import moment from 'moment'

export default {
  name: 'SubscriptionDetails',

  props: ['activeSubscription', 'subscriptions'],

  data() {
    return {
      allowEditing: false,
      editableFields: [],
      mandatoryFields: [],
      showLoader: false,
      fieldValues: []
    }
  },

  watch: {
    activeSubscription: function () {
      this.getMandatoryFields()
      this.getEditableFields()
    }
  },

  mounted() {
    this.getMandatoryFields()
    this.getEditableFields()
  },

  computed: {
    FullName() {
      return this.capitalizeFirstLetter(this.$auth.user().firstname) + ' ' + this.capitalizeFirstLetter(this.$auth.user().surname)
    },

    addressLine() {
      const address = this.findField(this.$auth.user().fields, item => item.id === 3)
      const zip = this.findField(this.$auth.user().fields, item => item.id === 4)
      const city = this.findField(this.$auth.user().fields, item => item.id === 5)

      return address.meta.value + ', ' + zip.meta.value + ' ' + city.meta.value
    },

    isNotInactive() {
      return this.activeSubscription.status !== 'inactive';
    },

    showMobilePayNotice() {
      return (this.activeSubscription.payment_method === 'mobile_pay' || this.activeSubscription.payment_method === 'vipps') &&
        (this.activeSubscription.status === 'active' || this.activeSubscription.status === 'delayed') &&
        this.activeSubscription.pricing.type === 'instant' &&
        this.activeSubscription.transaction_date > moment().format('YYYY-MM-DD')
    },

    hasMeters() {
      return (
        this.activeSubscription &&
        this.activeSubscription.kamstrup_meters &&
        this.activeSubscription.kamstrup_meters.length > 0
      );
    },

    currentMeter() {
      if (!this.activeSubscription || !this.activeSubscription.kamstrup_meters) return null
      return this.activeSubscription.kamstrup_meters.length > 0 ? this.activeSubscription.kamstrup_meters[0] : null
    },

    previousMeter() {
      if (!this.activeSubscription || !this.activeSubscription.kamstrup_meters) return null
      return this.activeSubscription.kamstrup_meters.length > 1 ? this.activeSubscription.kamstrup_meters[1] : null
    },

    currentFrom() {
      if (!this.currentMeter || !this.currentMeter.start_date) return '-'
      return this.currentMeter.start_date
    },

    currentTo() {
      if (!this.currentMeter || !this.currentMeter.end_date) return '-'
      return this.currentMeter.end_date
    },

    previousFrom() {
      if (!this.previousMeter || !this.previousMeter.start_date) return '-'
      return this.previousMeter.start_date
    },

    previousTo() {
      if (!this.previousMeter || !this.previousMeter.end_date) return '-'
      return this.previousMeter.end_date
    }
  },

  methods: {
    getLanguage() {
      if (this.$root.$i18n.locale) {
        return this.$root.$i18n.locale
      } else {
        if (window.localStorage.language) {
          return window.localStorage.language
        } else if (navigator.language) {
          return navigator.language
        } else {
          return 'da'
        }
      }
    },

    getMandatoryFields() {
      const _this = this
      this.mandatoryFields = []
      $.map(this.activeSubscription.product.fields, function (item, index) {
        if (!item.editable) {
          _this.mandatoryFields.push(item)
        }
      })
      if (this.activeSubscription.expire_date) {
        this.mandatoryFields.push({
          name: this.$t('components.transaction.info.expire_date'),
          type: 'date',
          meta: {
            value: this.activeSubscription.expire_date
          }
        })
      }
      return this.mandatoryFields
    },

    getEditableFields() {
      const _this = this
      this.editableFields = []
      $.map(this.activeSubscription.product.fields, function (item, index) {
        if (item.editable) {
          _this.editableFields.push(item)
        }
      })

      return this.editableFields
    },

    findField(array, condition) {
      return array.find(condition)
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    },

    chunkProperty(chunkedProperty, value) {
      return chunk(chunkedProperty, value)
    },

    changeFieldValue(field) {
      if (!find(this.fieldValues, {id: field.id})) {
        this.fieldValues.push(field)
      } else {
        var arrayValue = find(this.fieldValues, {id: field.id})
        if (field.value !== '') {
          arrayValue.value = field.value
        } else {
          this.fieldValues.splice(findIndex(this.fieldValues, {id: field.id}), 1)
        }
      }
    },

    showEditForm() {
      this.allowEditing = true
    },

    cancelEditForm(scope) {
      this.showLoader = true
      this.refreshMetaValues()
        .then(res => {
          // clear errors
          this.errors.clear(scope)
          // hide loader
          this.showLoader = false
          // allow editing
          this.allowEditing = false
        })
    },

    refreshMetaValues() {
      return new Promise((resolve, reject) => {
        this.$parent.refreshMetaValues(this.activeSubscription.id)
          .then(Fields => {
            this.getMandatoryFields()
            this.getEditableFields()

            this.showLoader = false // Disable loader
            this.allowEditing = false // Disable editing
            this.fieldValues = []
            resolve(true)
          }, error => {
            reject(error)
          })
      })
    },

    saveEditForm(scope) {
      this.$validator.validateAll(scope)
        .then(result => {
          if (result) {
            // Continue with form
            this.showLoader = true // Showing the loader
            const fields = []
            // handle editableFields
            $.map(this.fieldValues, function (item, index) {
              if (item.editable) {
                if (item.required) {
                  if (item.value !== '') {
                    fields.push({id: item.id, value: item.value})
                  }
                } else {
                  if (item.value === '') {
                    fields.push({id: item.id, value: null})
                  } else {
                    fields.push({id: item.id, value: item.value})
                  }
                }
              }
            })

            // make update request
            if (fields) {
              this.axios.put(`subscriptions/${this.activeSubscription.id}`, {
                fields: fields
              })
                .then(res => {
                  this.refreshMetaValues()
                }, () => {
                  this.refreshMetaValues()
                }).catch()
            } else {
              this.showLoader = false
              this.allowEditing = false
            }
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/SubscriptionDetails.vue